import {success, warning} from "@/utils/elMessage";

/**
 * 判空字符串
 * @param val 值
 * @returns {boolean} true：为空，false：不为空
 */
const isBlank = (val) => {
    if (typeof val !== 'string') {
        return val === undefined || val === null
    }
    return val.trim().length <= 0
}

/**
 * 判断对象是否为空
 * @param obj 要检查的对象
 * @returns {boolean} true：为空，false：不为空
 */
const isNullObj = (obj) => {
    // 如果不是对象或者为 null/undefined，则认为是空的
    if (typeof obj !== 'object' || obj === null || obj === undefined) {
        return true;
    }

    // 对于数组，如果长度为0则认为是空的
    if (Array.isArray(obj) && obj.length === 0) {
        return true;
    }

    // 检查对象自身的可枚举属性数量
    return Object.keys(obj).length === 0;
}

/**
 * 判空数组
 * @param arr 值
 * @returns {boolean} true：为空，false：不为空
 */
const isNullArray = (arr) => {
    // 检查传入的参数是否为数组
    if (!Array.isArray(arr)) {
        return arr === undefined || arr === null;
    }

    // 如果数组长度为0，则认为是空白数组
    return arr.length === 0;
};

/**
 * 随机获取数据
 * @param val
 * @returns {*}
 */
const getRandomData = (val) => {
    if (!Array.isArray(val)) {
        return val;
    }
    return val[Math.floor(Math.random() * val.length)]
}

/**
 * 是否包含
 * @param arr
 * @param val
 * @returns {*}
 */
const isContains = (arr, val) => {
    return arr.some(item => item === val)
}

/**
 * 下载
 */
const downloadFile = (res) => {
    let fileName
    try {
        const contentDisposition = res.headers['content-disposition']
        fileName = decodeURIComponent(contentDisposition.split('=')[1])
    } catch (e) {
        console.log(e)
        warning('文件名获取失败')
        fileName = 'downloadFile'
    }
    const url = window.URL.createObjectURL(new Blob([res.data], {type: res.headers['content-type']}))
    // 创建一个超链接，将文件流赋进去，然后实现这个超链接的单击事件
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    URL.revokeObjectURL(link.href) // 释放URL 对象
    document.body.removeChild(link)
    link = null
    success('下载成功')
}

/**
 * 复制
 * @param content
 */
const copyContent = (content) => {
    const textarea = document.createElement('textarea')
    textarea.value = content
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('Copy')
    textarea.remove()
}

/**
 * 转换格式
 * @param size
 */
const formatBytes = (size) => {
    if (size <= 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(size) / Math.log(k));

    return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

// 导出
export {
    isBlank,
    isNullArray,
    isNullObj,
    getRandomData,
    isContains,
    downloadFile,
    copyContent,
    formatBytes
}

